import { useState } from "react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { fmtLog } from "@/lib/tz";

// While Fully Funded Shifts support is signed in, every office screen says who, why and until when; anyone who may
// give support access can end it at once. The support person sees the same, from their side.
export function SupportBanner() {
  const { user, can, refreshUser } = useAuth();
  const [busy, setBusy] = useState(false);
  const s = user?.support_session;
  if (!s) return null;
  const end = async () => {
    setBusy(true);
    try {
      await api.endSupportSession();
      toast.success("Support session ended. Every admin will get the record by email.");
      refreshUser();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Couldn't end the support session");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div data-testid="support-banner" role="status"
      className="px-4 py-2 flex flex-wrap items-center justify-center gap-3 text-sm bg-orange-900 text-white">
      {user.support_mode ? (
        <span><b>You're signed in as FFS support</b> ({s.mode_label}) until {fmtLog(s.ends_at)}. Everything you open or
          change is recorded and sent to this provider's admins.</span>
      ) : (
        <span><b>FFS support is signed in:</b> {s.tech}, {s.mode_label}, until {fmtLog(s.ends_at)}
          {s.reason ? ` (${s.reason})` : ""}.</span>
      )}
      {!user.support_mode && can.has("support.grant") && (
        <button type="button" onClick={end} disabled={busy} data-testid="support-banner-end"
          className="min-h-[36px] rounded-md border border-white px-3 py-1 font-semibold hover:bg-white/10 disabled:opacity-60">
          End now
        </button>
      )}
    </div>
  );
}
